export default function calculateScaleAndDim(width: number, height: number, innerW: number, innerH: number) {
  let w = width;
  let h = height
  if (innerH > innerW) {
    w = height;
    h = width;
  }
  let scaleW = innerW / w;
  let scaleH = innerH / h;
  let scale = scaleW > scaleH ? scaleH : scaleW;
  let newWidth = scaleW > scaleH ? innerW / scale : w;

  let newHeight = scaleW > scaleH ? innerH / scale : h;

  return { scale, width: newWidth, height: newHeight }
}